import React from "react";
import PropTypes from "prop-types";
import styles from "./LimitedTextField.module.css";
import { CustomTextField } from "../text-fields";

const LimitedTextField = ({
	ref = null,
	autoFocus = false,
	className = "",
	color = "primary",
	containerClassName = "",
	disabled = false,
	error = false,
	fullWidth = false,
	InputProps = { className: styles.inputProps },
	helperText = "",
	label = "",
	maxLength = 256,
	maxRows,
	minRows,
	multiline = false,
	onBlur,
	onChange,
	onFocus,
	onKeyPress,
	onSelect,
	placeholder = "",
	required = false,
	rows,
	showHelper = true,
	size = "medium",
	sx = {},
	value = "",
	variant = "outlined",
	"data-testid": dataTestId = null,
	type = "text",
}) => {
	const handleChange = (e) => {
		if (e.target.value.length <= maxLength) {
			onChange(e.target.value);
		} else {
			onChange(e.target.value.substring(0, maxLength));
		}
	};
	// For multiline fields with empty label, don't pass label prop to allow placeholder to show
	// Material-UI TextField with multiline doesn't show placeholder when label prop is present (even if empty)
	const textFieldProps = {
		autoFocus,
		className: `${styles.tf} ${className}`,
		color,
		"data-testid": dataTestId,
		disabled,
		error,
		fullWidth,
		helperText,
		InputProps,
		multiline,
		placeholder,
		required,
		maxRows,
		minRows,
		rows,
		size,
		sx,
		type,
		value,
		variant,
		onBlur,
		onChange: handleChange,
		onFocus,
		onKeyPress,
		onSelect,
	};
	return (
		<span
			ref={ref}
			className={`${styles.wrapper} ${(fullWidth && styles["wrapper--fullWidth"]) || ""} ${containerClassName}`}
		>
			{(label || showHelper) && (
				<div className={styles.labelRow}>
					{label && (
						<div className={styles.label}>
							{label}
							{required && <span className={styles.required}>*</span>}
						</div>
					)}
					{showHelper && (
						<span className={styles.counter}>
							{value.length}/{maxLength}
						</span>
					)}
				</div>
			)}
			<CustomTextField {...textFieldProps} />
		</span>
	);
};

LimitedTextField.propTypes = {
	size: PropTypes.oneOf(["small", "medium"]),
};

export default LimitedTextField;
